const CONTENT_BLACKLIST: ReadonlyArray<{ key: string; reason: string }> = [
  { key: "type", reason: "Content type; set by schema/parser" },
  { key: "domain", reason: "Overlay domain; backend/config" },
  { key: "baseDir", reason: "Overlay base dir; backend/config" },
  { key: "index", reason: "Overlay index; backend/config" },
  { key: "year", reason: "Overlay year; backend/config" },
  { key: "key", reason: "Action/key identifier; often backend-defined" },
  { key: "specialization", reason: "Service specialization; backend-facing" },
  { key: "primary", reason: "Primary flag; internal structure" },
  {
    key: "conditionalOnVariable",
    reason: "Variable reference; backend/templating",
  },
  { key: "origin", reason: "Row/origin identifier; backend-facing" },
  {
    key: "contentFrom",
    reason: "Reference to external content; backend data binding",
  },
  { key: "chartType", reason: "Chart type; often fixed per section" },
];

const BLACKLIST_KEYS = CONTENT_BLACKLIST.map((x) => x.key);

const pathSegmentsForBlacklist = (field: string): string[] =>
  field.split(".").map((segment) => {
    const bracket = segment.indexOf("[");
    return bracket === -1 ? segment : segment.slice(0, bracket);
  });

export const toHideField = (field: string) => {
  const segments = pathSegmentsForBlacklist(field);
  return BLACKLIST_KEYS.some((key) => segments.includes(key));
};
